export const environment = {
  production: false,
  apiUrl: "https://stadiobet-api-dev.azurewebsites.net",
  aesSecret: "ThisIsOurSecretForCoaniProject@@",
  instrumentationKey: 'InstrumentationKey=e41b2c06-7d91-4146-90a4-3980eb1b0da3;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=1b8895ee-2ccb-4720-84cf-d7336b46665b'
};
